import React, { useEffect, useState } from "react"
import { IMG } from "../../../common/CONST"
import { IReplenishmentDto } from "../../../../types/replenishment/IReplenishmentDto"
import { download, getFormattedDate, spacedNum } from "../../../common/CommonHelper"
import { ReplenishmentErrorBlock } from "./ReplenishmentErrorBlock"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { IModalMessage } from "../../../../types/error/IModalMessage"
import { ModalPopUp } from "../../../common/element/ModalPopUp"
import { IBrockmanBankDto } from "../../../../types/brockman/IBrockmanBankDto"
import { getStorageUrl } from "@/lib/helper"
import { CommonInput } from "@/components/common/element/fields/CommonInput"
import { ClientRates } from "@/components/client/baseRates/Rates"

export const DocsCheckTab: React.FC<{
  next: () => void
  replenishment: IReplenishmentDto
  setReplenishment: (r: IReplenishmentDto) => void
}> = ({ next, replenishment, setReplenishment }) => {
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [sending, setSending] = useState<boolean>(false)
  const [banks, setBanks] = useState<IBrockmanBankDto[]>([])

  useEffect(() => {
    TrinityAPI.getBrockmanBanks(response => {
      if (response.status === 200) {
        setBanks(response.data)
      }
    })
  }, [])

  const handleNext = () => {
    if (replenishment.personalRateRequested && !replenishment.personalRate && !replenishment.onTopAmount) {
      setModalMessage({ title: "Ошибка!", text: "Вы не ввели индивидуальную ставку" })

      return
    }

    next()
  }

  const submit = (accepted: boolean) => {
    if (sending) return
    setSending(true)
    TrinityAPI.checkDocs(replenishment, accepted, response => {
      if (response.status === 200) {
        window.location.href = "/replenishment"
      } else {
        setModalMessage({ title: "Ошибка!", text: response.message })
        setSending(false)
      }
    })
  }

  if (replenishment.status === "NEW") {
    return (
      <>
        <div className="container">
          <div className="container-pop-up">
            <ul className="form-left">
              <li className="form-block-popup">
                <h4 className="heading-chapter">Загрузка документов</h4>
                <p className="message-course-yes">
                  Клиент заполняет первичные данные и загружает документы. Пожалуйста, дождитесь окончания процесса
                </p>
              </li>
            </ul>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <>
        <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
        <div className="container">
          <div className="container-pop-up">
            <ul className="form-left">
              {/*<div className="form-block-popup">*/}
              {/*  <h4 className="heading-chapter">*/}
              {/*    Пополнение на основании запроса №{replenishment.clientRequestId}*/}
              {/*  </h4>*/}
              {/*</div>*/}
              {replenishment.personalRateRequested && (
                <div className="form-block-popup">
                  <h4 className="heading-chapter" style={{ color: "red" }}>
                    Запрошена индивидуальная ставка
                  </h4>
                  <div className="flex-row-10">
                    <CommonInput
                      typeName={"text"}
                      label={"Ставка"}
                      placeholder={"12.25"}
                      name={"personalRate"}
                      value={replenishment.personalRate}
                      disabled={replenishment.status !== "DOC"}
                      errorModel={undefined}
                      _callback={e =>
                        setReplenishment({
                          ...replenishment,
                          personalRate: e
                        })
                      }
                    />
                    <CommonInput
                      typeName={"text"}
                      label={"Надбавка в фикс. сумме"}
                      placeholder={"10000"}
                      name={"onTopAmount"}
                      value={replenishment.onTopAmount}
                      disabled={replenishment.status !== "DOC"}
                      errorModel={undefined}
                      _callback={e =>
                        setReplenishment({
                          ...replenishment,
                          onTopAmount: e
                        })
                      }
                    />
                  </div>
                </div>
              )}

              <li className="form-block-popup">
                <h4 className="heading-chapter">Сумма пополнения в валюте</h4>
                <div className="flex-row-10">
                  <fieldset>
                    <legend>Дата инвойса</legend>
                    <p className="text-form">{getFormattedDate(replenishment.invoiceDate || "")}</p>
                  </fieldset>
                  <fieldset>
                    <legend>Номер инвойса</legend>
                    <p className="text-form">{replenishment.invoiceNumber}</p>
                  </fieldset>
                  <fieldset className="fieldset-fit">
                    <legend>Инвойс</legend>
                    <button
                      className="btn download-btn"
                      onClick={() => download(replenishment.id?.toString(), "CLIENT_INVOICE")}
                    >
                      <img src={IMG.download} alt="" />
                      Скачать
                    </button>
                  </fieldset>
                </div>
                <div className="flex-row-10">
                  <fieldset>
                    <legend>Сумма к оплате</legend>
                    <p className="text-form">
                      {spacedNum(replenishment.invoiceAmount ? Number(replenishment.invoiceAmount) / 100 : "")}
                    </p>
                  </fieldset>
                  <fieldset className="fieldset-200">
                    <legend>Валюта</legend>
                    <p className="text-form">{replenishment.invoiceCurrency}</p>
                  </fieldset>
                </div>
                <ReplenishmentErrorBlock
                  replenishment={replenishment}
                  setReplenishment={setReplenishment}
                  fieldName={"invoiceComment"}
                />
              </li>
              <li className="form-block-popup">
                <h4 className="heading-chapter">Контракт с заводом</h4>
                <div className="flex-row-10">
                  <fieldset>
                    <legend>Дата</legend>
                    <p className="text-form">{getFormattedDate(replenishment.contractDate || "")}</p>
                  </fieldset>
                  <fieldset>
                    <legend>Номер</legend>
                    <p className="text-form">№{replenishment.contractNumber}</p>
                  </fieldset>
                  <fieldset className="fieldset-fit">
                    <legend>Контракт</legend>
                    <button
                      className="btn download-btn"
                      onClick={() => download(replenishment.id?.toString(), "CLIENT_CONTRACT")}
                    >
                      <img src={IMG.download} alt="" />
                      Скачать
                    </button>
                  </fieldset>
                </div>
                <ReplenishmentErrorBlock
                  replenishment={replenishment}
                  setReplenishment={setReplenishment}
                  fieldName={"contractComment"}
                />
              </li>

              <div className="form-block-popup">
                <h4 className="heading-chapter">Комментарий</h4>

                {replenishment.status === "DOC" ? (
                  <input
                    type="text"
                    className="input-form"
                    placeholder="Введите комментарий"
                    onChange={e => setReplenishment({ ...replenishment, comment: e.target.value })}
                    value={replenishment.comment}
                    maxLength={15}
                  />
                ) : (
                  <p className="text-form">{replenishment.comment || "-"}</p>
                )}
              </div>
            </ul>
            <div className="right-form">
              <div className="form-block-popup">
                <h4 className="heading-chapter">Дополнительное соглашение</h4>
                <ul className="bank-deals-flex">
                  {banks.map((bank, index) => {
                    if (!(bank.id === replenishment.additionalAgreementBankId)) {
                      return null
                    }

                    return (
                      <li className="deals-bank-item--row" style={{ pointerEvents: "none" }} key={index}>
                        <img src={`${getStorageUrl()}/${bank.avatarPath}`} alt="" className="deals-bank-img" />
                        <span>
                          {bank.brockmanDetail?.shortName} - {bank.shortName}
                        </span>
                      </li>
                    )
                  })}
                </ul>
                <div className="flex-row-10">
                  <fieldset>
                    <legend>Дата</legend>
                    <p className="text-form">{getFormattedDate(replenishment.additionalAgreementDate || "")}</p>
                  </fieldset>
                  <fieldset>
                    <legend>Номер</legend>
                    <p className="text-form">№{replenishment.additionalAgreementNumber}</p>
                  </fieldset>
                </div>
                <div className="flex-row-10">
                  <button
                    className="btn download-btn"
                    onClick={() => download(replenishment.id?.toString(), "CLIENT_AGREEMENT")}
                  >
                    <img src={IMG.download} alt="" />
                    Скачать
                  </button>
                </div>
                <ReplenishmentErrorBlock
                  replenishment={replenishment}
                  setReplenishment={setReplenishment}
                  fieldName={"additionalAgreementComment"}
                />
              </div>

              <div className="flex-column-16">
                <ClientRates userId={replenishment?.userId} rateType={"AMOUNT"} />
                <ClientRates userId={replenishment?.userId} rateType={"M_VAL"} />
              </div>
            </div>

            {replenishment.status !== "DOC" ? (
              <></>
            ) : (
              <div className="flex-row-10">
                <button className="btn" onClick={handleNext}>
                  Далее
                </button>
                <button className="btn black-btn" onClick={() => submit(false)}>
                  {sending ? "Подождите..." : "Отправить на доработку"}
                </button>
                {/*<button className="btn grey-btn"*/}
                {/*        onClick={() => window.location.href = "/replenishment"}>В каталог пополнений*/}
                {/*</button>*/}
              </div>
            )}
          </div>
        </div>
      </>
    )
  }
}
